const $lists = $('.js-form-list');
const $submit = $('.js-form-submit');

$lists.each((index, item) => {
  const $list = $(item);
  const $listItems = $list.find('.js-form-list-item');
  const $target = $($list.attr('data-target'));

  $listItems.click(function (event) {
    event.preventDefault();

    const $this = $(this);
    const value = $this.attr('data-value');

    $submit.removeClass('disabled').removeAttr('disabled');
    $listItems.removeClass('active');
    $this.addClass('active');
    $target.val(value);
  });
});
